import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PatientAppointment } from 'src/app/entities/appointment.entity/patient-appointment.entity/patient-appointment';
import { User, EUserRole } from 'src/app/entities/user.entity';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { DoctorSecretary } from 'src/app/entities/user.entity/doctor.entity/secretary.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';

@Component({
  selector: 'app-appointment-patient-login',
  templateUrl: './appointment-patient-login.component.html',
  styleUrls: ['./appointment-patient-login.component.css']
})
export class AppointmentPatientLoginComponent implements OnInit {

  submited: boolean = false;
  isLoading: boolean = false;
  loginForm: FormGroup;
  @Input() dir:string="fr"
  @Input() patientAppointment!: PatientAppointment;

  get valid(): boolean {
    return this.loginForm.valid;
  }

  constructor(
    public router: Router,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private authService: AuthService,

  ) {
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      userPassword: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(): void {

  }

  get f() {
    return this.loginForm.controls;
  }

 onSubmit(): Promise<PatientAppointment> {
  this.submited = true;
  if (this.loginForm.invalid) {
    this.loginForm.markAllAsTouched();
    return Promise.reject('invalid-form');
  }
  this.isLoading = true;

  return new Promise((resolve, reject) => {
    const { userName, userPassword } = this.loginForm.value;
    this.authService.login({ email: userName, password: userPassword }).subscribe({
      next: (data) => {
        this.isLoading = false;
        const user = this.buildUser(data);
        this.authService.setCurrentUser(user); // ← à adapter à votre AuthService
        if (this.patientAppointment) this.patientAppointment.requested = false;
        resolve(this.patientAppointment);
      },
      error: (error) => {
        this.isLoading = false;
        this.handleError(error.status);
        reject(error);
      }
    });
  });
}

private buildUser(data: any): User {
  const role = data.user.role as string;
  let user: User;
  if (role === 'Medecin') user = Doctor.fromResponse(data.user);
  else if (role === 'Secretary') user = DoctorSecretary.fromResponse(data.user);
  else {
    user = User.fromResponse(data.user);
    if (role === 'Pharmacist') user.role = EUserRole.PHARMACIST;
  }
  user.accessToken = data.authToken;
  return user;
}

private handleError(status: number): void {
  switch (status) {
    case 403: this.f['userPassword'].setErrors({ invalidPassword: true }); break;
    case 404: this.f['userName'].setErrors({ notFound: true }); break;
    case 400: this.toaster.error('Service error !', 'Invalid login!'); break;
    case 408: this.toaster.error('Connectivity error!', 'Invalid login!'); break;
    case 500: this.toaster.error('Server error!', 'Invalid login!'); break;
    default:  this.toaster.error('Login error', 'Invalid login!');
  }
}

}
